import { action, makeObservable, observable, runInAction } from 'mobx';
import { RootStore } from '.';
import { AppInsightLog, errorCaptured } from '@commons/util';
import ajax from '@commons/api/ajax';
import CONFIG from '@commons/api/config';
// import { SHA256 } from 'crypto-js';
// import CryptoJS from 'crypto-js';
import i18n from '@translate/i18n';
import moment, { Moment } from 'moment';

import { MGMAccounts, MGMMainBanners, MGMQnas, MGMSeos, MGMShares, MGMTacticals, PortalContent } from '@interfaces/portal';
const API_ENV = CONFIG.API_ENV;
const API = CONFIG.API;
let instance: PortalStore;

export class PortalStore {
    RootStore: RootStore;
    constructor(RootStore: RootStore) {
        makeObservable(this);
        if (!instance) {
            instance = this;
        }
        this.RootStore = RootStore;
        return instance;
    }
    @observable orangeBarMgmCode: string = ''
    @observable portalContent: PortalContent = {}

    @action
    getPortalCommonContent = async () => {
        const [e, res] = await errorCaptured(
            ajax.get({
                url: API.GET_COMMON_CONTENT,
            })
        );
        console.log(e, 'content');
        if (e) return [e, res];
        runInAction(() => {
            this.generateLanguageResources(res.data.mgmAccounts, "mgmAccounts");
            this.generateLanguageResources(res.data.mgmMainBanners, "mgmMainBanners");
            this.generateLanguageResources(res.data.mgmQnas, "mgmQnas");
            this.generateLanguageResources(res.data.mgmRewordsOffers, "mgmRewordsOffers");
            this.generateLanguageResources(res.data.mgmSeos, "mgmSeos");
            this.generateLanguageResources(res.data.mgmShares, "mgmShares");
            this.generateLanguageResources(res.data.mgmTacticals, "mgmTacticals");
            this.portalContent = res.data;
        });
        return [e, res];
    };
    @action
    getTncCommonContent = async () => {
        const [e, res] = await errorCaptured(
            ajax.get({
                url: CONFIG.MGMPORTAL_API + `/common/${i18n.language === 'zh-HK' ? 'tc' : 'en'}/tnc` ,
            })
        );
        return [e, res]
    }

    @action
    getOrangeBarMgmCode = async () => {
        const [e, res] = await errorCaptured(
            ajax.get({
                url: CONFIG.API.GET_ORANGE_BAR_MGM_CODE
            })
        );
        runInAction(() => {
            this.orangeBarMgmCode = res.data ? res.data : ''
        })
        return [e, res]
    }

    
    // i18n.addResourceBundle(language, namespace, resources, deep, overwrite);
    /**
     * 
     * language: 目标语言代码（如 "en"）。
        namespace: 目标命名空间（如 "translation"）。
        resources: 一个包含嵌套结构的对象（可以是整个命名空间的资源包）。
        deep (可选): 是否深度合并与现有资源，默认 false。
        overwrite (可选): 是否覆盖现有资源，默认 false。
     */
    generateLanguageResources = (data: any, key:string) => {
        switch (key) {
            case "mgmAccounts":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedAccountData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedAccountData(data, 'Eng')}, true, false);
                break;
            case "mgmMainBanners":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedMainBannerData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedMainBannerData(data, 'Eng')}, true, false);
                break;
            case "mgmRewordsOffers":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedRewordsOffersData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedRewordsOffersData(data, 'Eng')}, true, false);
                break;
            case "mgmQnas":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedQnasData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedQnasData(data, 'Eng')}, true, false);
                break;
            case "mgmSeos":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedSeosData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedSeosData(data, 'Eng')}, true, false);
                break;
            case "mgmShares":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedSharesData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedSharesData(data, 'Eng')}, true, false);
                break;
            case "mgmTacticals":
                i18n.addResourceBundle("zh-HK", "portal", {[key]: this.convertToLocalizedTacticalsData(data, 'Chi')}, true, false);
                i18n.addResourceBundle("en-US", "portal", {[key]: this.convertToLocalizedTacticalsData(data, 'Eng')}, true, false);
                break;
            default:
                break;
        }
    }
    // 这个方法将会根据传入的语言标识符，选择对应的语言字段（Chi 或 Eng）
    // Account
    convertToLocalizedAccountData = (AccountData:MGMAccounts, language:string) => {
        // 动态选择字段，根据语言参数（Chi 或 Eng）
        const localizedItem = {
            refno: AccountData.refno,
            accountLoginIcon: AccountData.accountLoginIcon,
            copyText: AccountData[`copyText${language}`],
            newCustomerButtonText: AccountData[`newCustomerButtonText${language}`],
            referrerButtonText: AccountData[`referrerButtonText${language}`],
            referrerSelectedIconImageUrl: AccountData[`referrerSelectedIcon${language}ImageUrl`],
            referrerUnselectedIconImageUrl: AccountData[`referrerUnselectedIcon${language}ImageUrl`],
            referralTagLine: AccountData[`referralTagLine${language}`],
            phonePlaceHolder: AccountData[`phonePlaceHolder${language}`],
            ppsPlaceHolder: AccountData[`ppsPlaceHolder${language}`],
            newCustomerSelectedIconImageUrl: AccountData[`newCustomerSelectedIcon${language}ImageUrl`],
            newCustomerUnselectedIconImageUrl: AccountData[`newCustomerUnselectedIcon${language}ImageUrl`],
            referralCodeHolder: AccountData[`referralCodeHolder${language}`],
            newCustomerTagLine: AccountData[`newCustomerTagLine${language}`],
        };
        return localizedItem;
    };
    // mainbanner
    convertToLocalizedMainBannerData = (bannerData:MGMMainBanners[], language:string) => {
        return bannerData.map((item:any) => {
            // 动态选择字段，根据语言参数（Chi 或 Eng）
            const localizedItem = {
                refno: item.refno,
                bannerName: item.bannerName,
                desktopBannerImageUrl: item[`desktopBanner${language}ImageUrl`],
                tabletBannerImageUrl: item[`tabletBanner${language}ImageUrl`],
                mobileBannerImageUrl: item[`mobileBanner${language}ImageUrl`],
                subTitle: item[`subTitle${language}`],
                status: item.status,
                bannerButtons: item.bannerButtons.map((button:any) => ({
                    color: button.color,
                    linkUrl: button.linkUrl,
                    linkType: button.linkType,
                    buttonText: button[`buttonText${language}`]
                }))
            };
            return localizedItem;
        });
    };
    // QNA
    convertToLocalizedQnasData = (QnaData:MGMQnas[], language:string) => {
        return QnaData.map((item:any) => {
            // 动态选择字段，根据语言参数（Chi 或 Eng）
            const localizedItem = {
                refno: item.refno,
                qnaOrder: item.qnaOrder,
                question: item[`question${language}`],
                answer: item[`answer${language}`],
                status: item.status,
            };
            return localizedItem;
        });
    };
    // RewardsOffer
    convertToLocalizedRewordsOffersData = (TacticalsData:MGMTacticals[], language:string) => {
        return TacticalsData.map((item:any) => {
            // 动态选择字段，根据语言参数（Chi 或 Eng）
            const localizedItem = {
                refno: item.refno,
                offerName: item.offerName,
                link: item.link,
                siteType: item.siteType,
                desktopBannerImageUrl: item[`desktopBanner${language}ImageUrl`],
                tabletBannerImageUrl: item[`tabletBanner${language}ImageUrl`],
                mobileBannerImageUrl: item[`mobileBanner${language}ImageUrl`],
            };
            return localizedItem;
        });
    };
    // Seos
    convertToLocalizedSeosData = (SeoData:MGMSeos[], language:string) => {
        return SeoData.map((item:any) => {
            // 动态选择字段，根据语言参数（Chi 或 Eng）
            const localizedItem = {
                refno: item.refno,
                seoOrder: item.seoOrder,
                title: item[`title${language}`],
                description: item[`description${language}`],
                image: item[`image${language}`],
                status: item.status,
                iconList: item.iconList.map((seoItem:any) => ({
                    pixel: seoItem.pixel,
                    iconUrl: seoItem.iconUrl
                }))
            };
            return localizedItem;
        });
    };
    // Shares
    convertToLocalizedSharesData = (ShareData:MGMShares, language:string) => {
        const localizedItem = {
            refno: ShareData.refno,
            shareName: ShareData.shareName,
            facebookTitle: ShareData[`facebookTitle${language}`],
            facebookContent: ShareData[`facebookContent${language}`],
            emailSubject: ShareData[`emailSubject${language}`],
            emailContent: ShareData[`emailContent${language}`],
            imContent: ShareData[`imContent${language}`],
            nameCardImage: ShareData[`nameCardImage${language}`],
            nameCardRedirect: ShareData[`nameCardRedirect${language}`],
            facebookRedirectLink: ShareData.facebookRedirectLink,
            status: ShareData.status,
        };
        return localizedItem;
    };
    // Tactical
    convertToLocalizedTacticalsData = (TacticalsData:MGMTacticals[], language:string) => {
        return TacticalsData.map((item:any) => {
            // 动态选择字段，根据语言参数（Chi 或 Eng）
            const localizedItem = {
                refno: item.refno,
                offerName: item.offerName,
                link: item.link,
                siteType: item.siteType,
                desktopBannerImageUrl: item[`desktopBanner${language}ImageUrl`],
                tabletBannerImageUrl: item[`tabletBanner${language}ImageUrl`],
                mobileBannerImageUrl: item[`mobileBanner${language}ImageUrl`],
            };
            return localizedItem;
        });
    };
}

